// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bers-intro__headline{font-size:24px;font-weight:700;line-height:26px;margin-bottom:20px}.bers-intro__text{color:#00a0b9;font-weight:700}.bers-fieldset--deactived .bers-intro__text{color:#ace0e8;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
